// Leaderboard design tokens — imported from the CircleChess Leaderboard design
// (claude.ai design project "Circlechell leaderboard dashboard").
// Kept leaderboard-local so the screen stays pixel-perfect to the design
// without polluting the app-wide CCColors palette.
// This file is intentionally identical in cc-web-learning and cc-learning-app.

export const lbColors = {
  bg: '#FBF6EC',
  bgAlt: '#EFE7D6',
  card: '#FFFFFF',
  ink: '#2A2317',
  inkSoft: '#6E655A',
  muted: '#9A9184',
  faint: '#B4AC9B',
  line: '#F0E9DA',
  lineSoft: '#F5F0E5',

  gold: '#F5C33C',
  goldDeep: '#E0A011',
  goldInk: '#3A2C05',
  goldSoft: '#FBE9B4',
  youRowBg: '#FCF3D6',
  flashBg: '#FBE4A6',
  youChipBg: '#FBEBBA',
  youChipLabel: '#9A7A1B',
  youChipSub: '#6E5310',
  rowBg: '#FBF8F1',
  barTrack: '#F1EADB',
  barGold: '#E9C97A',

  dark: '#1D1608',
  darkPanel: '#3A2C10',
  darkText: '#C9BE9E',

  teal: '#2AA091',
  orange: '#EA6A2C',
  green: '#3DA35D',
  greenBg: '#EAF6EE',
  greenInk: '#2E7D46',
  red: '#DA6038',
};

export interface Medal {
  bg: string;
  tx: string;
}

// Gold / silver / bronze for the top three ranks.
export const MEDAL: Record<number, Medal> = {
  1: {bg: '#F5C33C', tx: '#3A2C05'},
  2: {bg: '#D4D7DE', tx: '#3A3A3A'},
  3: {bg: '#E0A870', tx: '#3A2405'},
};

// Avatar palette (assigned per player, keyed on userid).
export const AVATAR_PALETTE = [
  '#E86A2C',
  '#C25FC9',
  '#47A6D6',
  '#2AA091',
  '#E0A93C',
  '#7C6BD8',
  '#D6693A',
  '#3DA35D',
  '#D95F8E',
  '#5A9E4F',
  '#C87BE0',
  '#4E8FD1',
];

export function avatarColorForUser(userid: number | string): string {
  const n =
    typeof userid === 'number'
      ? userid
      : Math.abs(
          String(userid)
            .split('')
            .reduce((acc, ch) => acc + ch.charCodeAt(0), 0),
        );
  return AVATAR_PALETTE[Math.abs(n) % AVATAR_PALETTE.length];
}

export const lbRadius = {sm: 10, md: 14, lg: 18, xl: 22, pill: 999};

// Responsive breakpoint: >= this width uses the wide (tablet / desktop) layout.
export const WIDE_BREAKPOINT = 720;

export const lbShadow = {
  card: {
    shadowColor: '#3C3014',
    shadowOpacity: 0.07,
    shadowRadius: 20,
    shadowOffset: {width: 0, height: 6},
    elevation: 3,
  },
};

// How long a freshly-won row stays highlighted, ms.
export const FLASH_MS = 1700;
